import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appMuTableCell]',
})
export class MuTableCellDirective {
  @Input('appMuTableCell') name: string;

  constructor(public template: TemplateRef<any>) {
    /** */
  }
}
